import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useRequestData } from 'wsm-common-data';
import { trackEvent } from 'ddc-track-event';
import { noPrice } from '../../global-constants';
import useFetchFacets from '../../hooks/useFetchFacets';
import useFormatNumber from '../../hooks/useFormatNumber';
import { MODAL } from '../../constant';
/* eslint react/no-danger: 0 */

const NoPriceButton = ({
	id,
	noPriceCount,
	noPriceLabel,
	isDisabled,
	isSelected,
	selectedValues
}) => {
	const [isActive, setActive] = useState(isSelected);
	const [filters, setFilter] = useState(null);
	const formatNumber = useFormatNumber();
	const { windowId, widgetName } = useRequestData();

	useFetchFacets(filters, MODAL);
	useEffect(() => {
		setActive(isSelected);
	}, [isSelected]);

	/**
	 * This function calls the setFilterSelections method to update the url with vehicles with no price
	 * It will also removes vehicles with no price when appropriate.
	 */
	const toggleNoPrices = () => {
		setActive(!isActive);
		const updatedSelections = [];
		selectedValues.map((selected) =>
			updatedSelections.push(selected.value)
		);

		if (isActive) {
			updatedSelections.splice(updatedSelections.indexOf(noPrice), 1);
		} else {
			updatedSelections.push(noPrice);
		}

		setFilter({ [id]: updatedSelections });

		trackEvent(`${widgetName}-modal`, windowId, {
			action: 'applied',
			element: `${id} selection`,
			elementCTA: 'Include "No Price Available"',
			result: 'Results updated with facet added'
		});
	};

	/**
	 * Sanitizes data coming from DDC.InvData labels
	 * @returns {{__html: string}}
	 */
	const createMarkup = () => {
		return { __html: `${noPriceLabel}` };
	};

	return (
		<li className="no-price-btn checkbox text-center mt-5">
			<label
				htmlFor={`${id}-includeNoPrice`}
				className={isDisabled ? 'disabled' : null}
			>
				<input
					type="checkbox"
					name="no-price-btn"
					value={noPriceLabel}
					id={`${id}-includeNoPrice`}
					onChange={toggleNoPrices}
					disabled={isDisabled}
					checked={isActive}
				/>
				<span className="facet-list-facet-label-text-container">
					<span dangerouslySetInnerHTML={createMarkup()} />
					{noPriceCount && (
						<small className="ddc-font-size-xsmall">
							{formatNumber(noPriceCount)}
						</small>
					)}
				</span>
			</label>
		</li>
	);
};

NoPriceButton.propTypes = {
	id: PropTypes.string.isRequired,
	isSelected: PropTypes.bool.isRequired,
	noPriceCount: PropTypes.number.isRequired,
	noPriceLabel: PropTypes.string.isRequired,
	selectedValues: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
	isDisabled: PropTypes.bool.isRequired
};

export default NoPriceButton;
